import React from 'react';

/**
 * PieChartHint
 * - Hint kecil untuk aturan pie chart
 * - Presentational only
 */
export default function PieChartHint(props) {
  const { isVisible } = props;

  if (!isVisible) return null;

  return (
    <small className="text-muted d-block">
      Setiap nilai jawaban harus minimal 5 untuk tipe Pie Chart.
    </small>
  );
}